<template>
    <Trombinoscope 
      Title="Tous"
      :projects="AllProjects"
      baseRoute="/portfolio/tous"
    />
</template>






<script>


import Trombinoscope from '@/components/Trombinoscope.vue';




export default {
  components:{
    Trombinoscope
  },
  data() {
    return {
      AllProjects: [
      {
        nom: 'Quantum',
        description: "Création d'une marque de bière fictive",
        background: '/img/projet/LOGOQUANTUMBLANC.jpg',
        skills: ['photoshop.png', 'illustrator.png', 'canva.png', 'js.svg', 'html.svg', 'css.svg', 'php.png'],
        date: "Juin 2024"
      },
      {
        nom: 'Eh Connard !',
        description: "Création d'une association féministe fictive",
        background: '/img/projet/logoEhConnard.jpg',
        skills: ['photoshop.png', 'illustrator.png', 'canva.png', 'js.svg', 'html.svg', 'css.svg', 'php.png'],
        date: "Janvier 2024"
      },
      // {
      //   nom: 'Mbappé',
      //   description: 'Affiche sur Kylian Mbappé',
      //   background: '/img/projet/kylian.jpg',
      //   skills: ['photoshop.png'],
      //   date: "Octobre 2024"
      // },
      {
        nom: 'Bande-Dessinée',
        description: "Bande-dessinée interactive",
        background: '/img/projet/bande-dessinee.jpg',
        skills: ['animate.png', 'illustrator.png'],
        date: "Novembre 2024"
      },
      {
        nom: 'Gyökeres',
        description: "Affiche sur Viktor Gyökeres",
        background: '/img/projet/gyokeres.jpg',
        skills: ['photoshop.png'],
        date: "Novembre 2024"
      },
      {
        nom: 'Site Quantum',
        description: "Site web de vente de bière",
        background: '/img/projet/quantum.jpg',
        date: "Juin 2024",
        skills: ['php.png', 'css.svg', 'js.svg', 'filezilla.png', 'vscode.png']
      },
      {
        nom: 'Vitinha',
        description: 'Affiche sur Vitinha',
        background: '/img/projet/vitinha.jpg',
        skills: ['photoshop.png'],
        date: "Novembre 2024"
      },
      // {
      //   nom: 'Marseille.fr',
      //   description: 'Maquette du site web de Marseille sur axure',
      //   background: '/img/projet/marseille.jpg',
      //   date: "Mars 2024",
      //   skills: ['axure.png']
      // },
      {
        nom: 'Shanks',
        description: 'Affiche sur Shanks de One Piece',
        background: '/img/projet/shanks.jpg',
        skills: ['photoshop.png'],
        date: "Mars 2024"
      },
      {
        nom: 'New World Symphony',
        description: 'Clip audiovisuel',
        background: '/img/projet/clip.jpg',
        date: 'Juin 2024',
        skills: ["premierepro.png", "canva.png"]
      },
      {
        nom: 'Vitinha 2.0',
        description: 'Double éclairage sur Vitinha',
        background: '/img/projet/vitinha2.jpg',
        skills: ['photoshop.png'],
        date: "Novembre 2024"
      },
      {
        nom: 'João Neves',
        description: 'Affiche sur João Neves',
        background: '/img/projet/joaoNeves.jpg',
        skills: ['photoshop.png'],
        date: "Août 2024"
      },
      {
        nom: "Scène d'épouvante",
        description: 'Vidéo épouvante réalisée avec la caméra 3D sur After Effects',
        background: '/img/projet/epouvante.jpg',
        date: 'Novembre 2024',
        skills: ["aftereffects.png", "photoshop.png"]
      },
      {
        nom: 'Limites planétaires',
        description: 'Affiche sur les limites planétaires',
        background: '/img/projet/limitesPlanetaires.jpg',
        skills: ['illustrator.png'],
        date: "Avril 2024"
      },
      {
        nom: 'Shanks Website',
        description: 'Site web consacré au personnage de Shanks dans One Piece',
        background: '/img/projet/shanksSite.jpg',
        date: "Avril 2024",
        skills: ['html.svg', 'css.svg', 'js.svg', 'vscode.png']
      },
      {
        nom: 'JME',
        description: 'Affiche pour promouvoir la journée mondiale de l\'eau',
        background: '/img/projet/JME.jpg',
        skills: ['photoshop.png'],
        date: "Novembre 2023"
      },
      // {
      //   nom: 'AccessiWeb',
      //   description: "Maquette axure visant à expliquer tous les rouages de l'accessibilité sur le web",
      //   background: '/img/projet/accessiWeb.jpg',
      //   date: "Avril 2024",
      //   skills: ['axure.png']
      // },
      {
        nom: 'Auto-Portrait',
        description: 'Auto-Portrait',
        background: '/img/projet/autoPortrait.jpg',
        skills: ['illustrator.png'],
        date: "Novembre 2023"
      },
      // {
      //   nom: 'ErgoWeb',
      //   description: "Maquette axure traitant de l'ergonomie web",
      //   background: '/img/projet/ergoWeb.jpg',
      //   date: "Décembre 2023",
      //   skills: ['axure.png']
      // },
      // {
      //   nom: 'Cartel',
      //   description: 'Affiche inspirée des cartels de la drogue sud-américains',
      //   background: '/img/projet/cartel.jpg',
      //   skills: ['photoshop.png'],
      //   date: "Octobre 2024"
      // },
      {
        nom: 'Films du moment',
        description: 'Page web présentant les films du moment',
        background: '/img/projet/filmDuMoment.jpg',
        date: "Mars 2024",
        skills: ['html.svg', 'css.svg', 'vscode.png']
      },
      {
        nom: 'Digital Detox',
        description: "Vidéo sur la détox digital",
        background: '/img/projet/digitaldetox.jpg',
        date: "Avril 2024 ",
        skills: ["premierepro.png"]
      },
      {
        nom: 'Les Arènes',
        description: "Vidéo sur les Arènes d'Évry-Courcouronnes",
        background: '/img/projet/lesArenes.jpg',
        date: 'Novembre 2024',
        skills: ["premierepro.png"]
      },
      {
        nom: 'Festival',
        description: 'Affiche pour une campagne de festival pour la jeunesse européenne',
        background: '/img/projet/festival.jpg',
        skills: ['photoshop.png'],
        date: "Juin 2024"
      },
      {
        nom: 'Barcola',
        description: 'Affiche sur Bradley Barcola',
        background: '/img/projet/barcola.jpg',
        skills: ['photoshop.png'],
        date: "Août 2024"
      },
      {
        nom: 'Player',
        description: "Reproduction d'un player audio",
        background: '/img/projet/player.jpg',
        date: "Octobre 2024",
        skills: ["/aftereffects.png", "illustrator.png"]
      },
      {
        nom: 'Lame secrète',
        description: 'Téléphone lame secrète',
        background: '/img/projet/lameSecrete.jpg',
        skills: ['photoshop.png'],
        date: "Décembre 2023"
      },
      {
        nom: 'Site Eh Connard!',
        description: 'Site web féministe',
        background: '/img/projet/ehConnard.jpg',
        date: "Janvier 2024",
        skills: ['php.png', 'css.svg', 'vscode.png']
      },
      {
        nom: 'Campagne publicitaire',
        description: "Affiche campagne publicitaire contre l'étalement urbain",
        background: '/img/projet/campagnePublicitaire.jpg',
        skills: ['photoshop.png'],
        date: "Décembre 2024"
      },
      {
        nom: 'Générique',
        description: 'Générique de fin de comédie romantique',
        background: '/img/projet/generique.jpg',
        date: "Janvier 2025",
        skills: ["/aftereffects.png"]
      },
      // {
      //   nom: "Bat'H Game",
      //   description: "Application interactive d'escape game conçue pour le bâtiment H de notre IUT",
      //   background: '/img/projet/bath.jpg',
      //   date: "Mai 2025",
      //   brief: "Créer une vidéo de générique de fin de comédie romantique",
      //   skills: ['flutterflow.png','gdoc.png']
      // },
      {
        nom: 'Sapik',
        description: "Remodernisation d'une marque de  piment fictive",
        background: '/img/projet/sapik.jpg',
        skills: ['photoshop.png', 'illustrator.png', 'canva.png'],
        date: "Mars 2025"
      },
      {
        nom: 'Infographie animée',
        description: "Infographie animée sur le thème de la difficulté",
        background: '/img/projet/infographie.jpg',
        skills: ['illustrator.png', 'animate.png'],
        date: "Janvier 2025"
      },
      {
        nom: 'Site WordPress',
        description: 'Site WordPress sur le thème du jeu-vidéo',
        background: '/img/projet/themeWordPress.jpg',
        date: "Janvier 2025",
        skills: ['wordpress.png', 'vscode.png', 'canva.png']
      },
      {
        nom: 'Expérience 360',
        description: 'Expérience 360 interactive',
        background: '/img/projet/experience360.jpg',
        date: "Avril 2025",
        skills: ["/sphere.png"]
      },
      {
        nom: 'Scénario 360',
        description: 'Court-métrage basé sur un scénario 360',
        background: '/img/projet/scenario360.jpg',
        date: "Janvier 2025",
        skills: ["/premierepro.png"]
      },
      {
        nom: 'Génome',
        description: "Vidéo d'analyse de génome sur After Effects",
        background: '/img/projet/genome.jpg',
        date: "Avril 2025",
        skills: ["/aftereffects.png", '/illustrator.png']
      },
      {
        nom: 'Carte de voeux',
        description: 'Carte de voeux animée pour la nouvelle année 2025',
        background: '/img/projet/carteDeVoeux.jpg',
        date: "Janvier 2025",
        skills: ["/aftereffects.png"]
      },
      {
        nom: 'PSG - City',
        description: "Affiche d'avant match PSG - Manchester City",
        background: '/img/projet/psg-city.jpg',
        skills: ['photoshop.png'],
        date: "Janvier 2025"
      },
      {
        nom: 'Mbappé',
        description: "Affiche sur Kylian Mbappé",
        background: '/img/projet/kylian2.jpg',
        skills: ['photoshop.png'],
        date: "Août 2024"
      },
      {
        nom: 'Matchday',
        description: "Jour de match du PSG",
        background: '/img/projet/matchday.jpg',
        skills: ['photoshop.png'],
        date: "Août 2024"
      },
      {
        nom: 'Landing Page',
        description: "Landing page du site de l'IUT Sénart-Fontainebleau",
        background: '/img/projet/landingPage.jpg',
        date: "Novembre 2024",
        skills: ['html.svg', 'css.svg', 'vscode.png', 'js.svg']
      },
      {
        nom: 'Je filme ma formation',
        description: "Vidéo de présentation de la formation MMI",
        background: '/img/projet/jeFilmeMaFormation.jpg',
        date: "Janvier 2025",
        skills: ["/premierepro.png"]
      },
      {
        nom: 'Kvaratskhelia',
        description: "Entrainement au light avec Kvaratskhelia",
        background: '/img/projet/kvaratskhelia.png',
        skills: ['photoshop.png'],
        date: "Février 2025"
      },
      {
        nom: 'Kvaratskhelia 2',
        description: "Entrainement au light avec Kvaratskhelia",
        background: '/img/projet/kvaratskhelia2.jpg',
        skills: ['photoshop.png'],
        date: "Février 2025"
      },
      {
        nom: 'Kvaratskhelia 3',
        description: "Affiche sur Khvicha Kvaratskhelia",
        background: '/img/projet/kvaratskhelia3.jpg',
        skills: ['photoshop.png'],
        date: "Février 2025"
      },
      {
     
        nom: 'Bannière',
        description: "Bannière LinkedIn",
        background: '/img/projet/banniere.jpg',
        skills: ['canva.png'],
        date: "Mai 2025"
      },
      {
        nom: 'Quantum stagiaire',
        description: "Affiche promotionnelle pour un poste de stagiaire chargé(e) de communication chez Quantum",
        background: '/img/projet/stagiaire.jpg',
        skills: ['photoshop.png'],
        date: "Mai 2025"
      },
      {
        nom: 'Golden Boy',
        description: "Affiche sur Désiré Doué",
        background: '/img/projet/doue.jpg',
        skills: ['photoshop.png'],
        date: "Juillet 2025"
      },
      {
        nom: 'Effet Vintage',
        description: "Effet vintage sur une photo de moi",
        background: '/img/projet/oldPicture.jpg',
        skills: ['photoshop.png'],
        date: "Mars 2025"
      },
      { 
          nom: 'Entretien étudiant',
           description: "Montage de l'entretien d'un étudiant en MMI sur le thème du numérique", 
           background: '/img/projet/entretien.jpg',
           date:"Octobre 2025",
           skills:["/premierepro.png"]
          },
          { 
          nom: 'Micro-trottoir',
           description: "Montage du micro-trottoir d'un sénior sur le thème du numérique", 
           background: '/img/projet/microTrottoir.jpg',
           date:"Janvier 2026",
           skills:["/premierepro.png"]
          },
           { 
          nom: 'Impasse',
           description: "Court-métrage de l'association Next.Us", 
           background: '/img/projet/impasse.jpg',
           date:"Mars 2026",
           skills:["/premierepro.png","aftereffects.png"],
          },
          { 
           nom: "Site Next.Us",
           description: "Site de l'association Next.Us", 
           background: '/img/projet/site-nextus.png',
           date:"Mars 2026",
           skills:['wordpress.png','vscode.png']
          },
    ]
    };
  },
};


</script>




<style scoped>

</style>